import { render, staticRenderFns } from "./DriverDocumentsSearchBox.vue?vue&type=template&id=a533ad1a&"
import script from "./DriverDocumentsSearchBox.vue?vue&type=script&lang=js&"
export * from "./DriverDocumentsSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./DriverDocumentsSearchBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports